export const UPDATE_PROFILE_PAGE = 'UPDATE_PROFILE_PAGE';

export const UPDATE_PROFILE_PAGE_HEADER_FLOAT =
  'UPDATE_PROFILE_PAGE_HEADER_FLOAT';
export const UPDATE_PROFILE_PAGE_SCROLL_TO_NAV =
  'UPDATE_PROFILE_PAGE_SCROLL_TO_NAV';

export const UPDATE_PROFILE_PAGE_HEADER_COLOR_PREVIEW =
  'UPDATE_PROFILE_PAGE_HEADER_COLOR_PREVIEW';
export const UPDATE_PROFILE_PAGE_HEADER_COLOR_SAVING =
  'UPDATE_PROFILE_PAGE_HEADER_COLOR_SAVING';
export const UPDATE_PROFILE_PAGE_HEADER_COLOR_PICKER =
  'UPDATE_PROFILE_PAGE_HEADER_COLOR_PICKER';

export const UPDATE_PROFILE_PAGE_FULLNAME_PREVIEW =
  'UPDATE_PROFILE_PAGE_FULLNAME_PREVIEW';
export const UPDATE_PROFILE_PAGE_FULLNAME_EDITING =
  'UPDATE_PROFILE_PAGE_FULLNAME_EDITING';
export const UPDATE_PROFILE_PAGE_FULLNAME_SAVING =
  'UPDATE_PROFILE_PAGE_FULLNAME_SAVING';
export const UPDATE_PROFILE_PAGE_FULLNAME_WIDTH =
  'UPDATE_PROFILE_PAGE_FULLNAME_WIDTH';

export const UPDATE_PROFILE_PAGE_SHARE_SHOW = 'UPDATE_PROFILE_PAGE_SHARE_SHOW';
export const UPDATE_PROFILE_PAGE_SHOW_ALL_BADGES =
  'UPDATE_PROFILE_PAGE_SHOW_ALL_BADGES';
export const UPDATE_PROFILE_PAGE_SHOW_ALL_FANS =
  'UPDATE_PROFILE_PAGE_SHOW_ALL_FANS';

export const UPDATE_PROFILE_PAGE_SET_PAGE_DIRTY =
  'UPDATE_PROFILE_PAGE_SET_PAGE_DIRTY';
export const UPDATE_PROFILE_PAGE_SET_WARNING_CALLBACK =
  'UPDATE_PROFILE_PAGE_SET_WARNING_CALLBACK';
